import AreaComponent from '@/components/AreaWithRegistComponent.vue';
import BrandComboBoxComponent from '@/components/BrandComboBoxWithRegistComponent.vue';
import BusinessComponent from '@/components/BusinessNoWithRegistComponent.vue';
import ButtonComponent from '@/components/ButtonWithRegistComponent.vue';
import CheckBoxComponent from '@/components/CheckBoxWithRegistComponent.vue';
import ColInsuranceComponent from '@/components/ColInsuranceWithRegistComponent.vue';
import ComInsurancComponent from '@/components/ComInsuranceWithRegistComponent.vue';
import ComboBoxComponent from '@/components/ComboBoxWithRegistComponent.vue';
import CustomComboBoxComponent from '@/components/CustomComboboxWithRegistComponent.vue';
import DatePickerDualComponent from '@/components/DatePickerDualComponent.vue';
import DatePickerComponent from '@/components/DatePickerWithRegistComponent.vue';
import DateYearComponent from '@/components/DatePickerYearWithRegistComponent.vue';
import DeliveryComponent from '@/components/DeliveryWithRegistComponent.vue';
import DriverComponent from '@/components/DriverWithRegistComponent.vue';
import EmailComponent from '@/components/EmailWithRegistComponent.vue';
import GarageComponent from '@/components/GarageWithRegistComponent.vue';
import ImageComponent from '@/components/ImageWithRegistComponent.vue';
import InjuryComponent from '@/components/InjuryWithRegistComponent.vue';
import InputBoxComponent from '@/components/InputBoxWithRegistComponent.vue';
import LabelComponent from '@/components/LabelWithRegistComponent.vue';
import LoginIdComponent from '@/components/LoginIdWithRegistComponent.vue';
import MobileCheckComponent from '@/components/MobileCheckWithRegistComponent.vue';
import ModelComponent from '@/components/ModelWithRegistComponent.vue';
import MultiCheckBoxComponent from '@/components/MultiCheckBoxWithRegistComponent.vue';
import MultiComboBoxComponent from '@/components/MultiComboBoxWithRegistComponent.vue';
import MultiUploadBoxWithRegistComponent from '@/components/MultiUploadBoxWithRegistComponent.vue';
import RadioButtonComponent from '@/components/RadioButtonWithRegistComponent.vue';
import SelectBoxComponent from '@/components/SelectBoxWithRegistComponent.vue';
import SignComponent from '@/components/SignWithRegistComponent.vue';
import TextAreaComponent from '@/components/TextAreaWithRegistComponent.vue';
import TimeComboBoxComponent from '@/components/TimeComboBoxWithRegistComponent.vue';
import TimePickerComponent from '@/components/TimePickerComponent.vue';
import VehicleGroupComponent from '@/components/VehicleGroupWithRegistComponent.vue';
import VehicleNoComponent from '@/components/VehicleNoWithRegistComponent.vue';
import VehicleOptionComponent from '@/components/VehicleOptionWithRegistComponent.vue';
import VehicleComponent from '@/components/VehicleWithRegistComponent.vue';
import Editor from 'primevue/editor';

import '@/assets/styles.scss';
import '@/assets/tailwind.css';
import { useAuthStore } from '@/store/auth-store';
import { useCommonCodeStore } from '@/store/commoncode-store';
import { useLoadingStore } from '@/store/loading-store';
import { useReservationCartStore } from '@/store/reservationCart-store';
import { useRouterStore } from '@/store/router-store';
import { loadScript } from '@/utils/scriptLoader';
import { definePreset } from '@primevue/themes';
import Aura from '@primevue/themes/aura';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridVue } from 'ag-grid-vue3';
import { createPinia } from 'pinia';
import piniaPersistedstate from 'pinia-plugin-persistedstate';
import 'primeicons/primeicons.css';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import { createApp, watch } from 'vue';
import App from './App.vue';
import router, { addDynamicRoutes } from './router';

const app = createApp(App);
app.component('inputbox', InputBoxComponent);
app.component('custom-inputbox', InputBoxComponent);
app.component('textarea', TextAreaComponent);
app.component('selectbox', SelectBoxComponent);
app.component('combobox', ComboBoxComponent);
app.component('brandcombobox', BrandComboBoxComponent);
app.component('datepicker', DatePickerComponent);
app.component('custom-datepicker', DatePickerComponent);
app.component('datepickerDual', DatePickerDualComponent);
app.component('timepicker', TimePickerComponent);
app.component('checkbox', CheckBoxComponent);
app.component('multicheckbox', MultiCheckBoxComponent);
app.component('multiuploadbox', MultiUploadBoxWithRegistComponent);
app.component('radiobutton', RadioButtonComponent);
app.component('area', AreaComponent);
app.component('vehiclegroup', VehicleGroupComponent);
app.component('vehicleoption', VehicleOptionComponent);
app.component('image', ImageComponent);
app.component('sign', SignComponent);
app.component('button', ButtonComponent);
app.component('label', LabelComponent);
app.component('vehicle', VehicleComponent);
app.component('delivery', DeliveryComponent);
app.component('driver', DriverComponent);
app.component('injury', InjuryComponent);
app.component('email', EmailComponent);
app.component('mobile', MobileCheckComponent);
app.component('custom-mobile', MobileCheckComponent);
app.component('colinsurance', ColInsuranceComponent);
app.component('cominsurance', ComInsurancComponent);
app.component('dateyear', DateYearComponent);
app.component('garage', GarageComponent);
app.component('loginid', LoginIdComponent);
app.component('model', ModelComponent);
app.component('vehicleno', VehicleNoComponent);
app.component('Editor', Editor);
app.component('timecombobox', TimeComboBoxComponent);
app.component('customcombobox', CustomComboBoxComponent);
app.component('multicombobox', MultiComboBoxComponent);
app.component('business', BusinessComponent);

const pinia = createPinia();
pinia.use(piniaPersistedstate);
app.use(pinia);

app.component('AgGridVue', AgGridVue);

const MyPreset = definePreset(Aura, {
    colors: {
        indigo: {
            50: '#E6ECFE',
            100: '#C2D1FD',
            200: '#9EB6FC',
            300: '#7A9BFB',
            400: '#5680FA',
            500: '#0038EA', // 여기에 원하는 기본 색상을 설정
            600: '#002DC2',
            700: '#00229A',
            800: '#001672',
            900: '#000B4A',
            950: '#000524'
        }
    },
    semantic: {
        primary: {
            50: '{indigo.50}',
            100: '{indigo.100}',
            200: '{indigo.200}',
            300: '{indigo.300}',
            400: '{indigo.400}',
            500: '{indigo.500}',
            600: '{indigo.600}',
            700: '{indigo.700}',
            800: '{indigo.800}',
            900: '{indigo.900}',
            950: '{indigo.950}'
        }
    }
});

async function initKakaoMap() {
    try {
        await loadScript('https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js');
        return window.daum;
    } catch (error) {
        console.error('kakao Map Api 초기화 실패:', error);
        return null;
    }
}

async function initTossPayments() {
    const clientKey = 'test_gck_docs_Ovk5rk1EwkEbP0W43n07xlzm';
    try {
        await loadScript('https://js.tosspayments.com/v2/standard');
        if (typeof window.TossPayments !== 'undefined') {
            const tossPaymentsInstance = window.TossPayments(clientKey);
            console.log('TossPayments 객체 초기화 완료:', tossPaymentsInstance);
            return tossPaymentsInstance;
        } else {
            console.error('토스페이먼츠 라이브러리가 로드되지 않았습니다');
            return null;
        }
    } catch (error) {
        console.error('TossPayments 초기화 실패:', error);
        // 여기서 사용자에게 알림을 표시
        return null;
    }
}

// app.use(PrimeVue, {
//     theme: {
//         preset: MyPreset,
//         options: {
//             darkModeSelector: '.app-dark'
//         }
//     }
// });
// app.use(ToastService);
// app.use(ConfirmationService);
// const loadingStore = useLoadingStore();

// router.beforeEach((to, from, next) => {
//     loadingStore.showLoading();
//     next();
// });

// router.afterEach(() => {
//     loadingStore.hideLoading();
// });

async function initializeApp() {
    const authStore = useAuthStore();
    const routerStore = useRouterStore();
    const commonCodeStore = useCommonCodeStore();
    const loadingStore = useLoadingStore();
    const cartStore = useReservationCartStore();
    await routerStore.fetchRouterItems();

    app.use(PrimeVue, {
        theme: {
            preset: MyPreset,
            options: {
                darkModeSelector: '.app-dark'
            }
        }
    });
    app.use(ToastService);
    app.use(ConfirmationService);

    // 라우터 설정 및 동적 라우트 추가
    app.use(router); // 라우터 초기화 및 연결

    authStore.initializeAuth();
    try {
        const isAuthenticated = await authStore.checkAuth();
        if (isAuthenticated) {
            authStore.refreshUserInfo().catch((error) => {
                console.error('계정 정보 갱신 실패:', error);
                // authStore.logout();
            });
        }
    } catch (error) {}

    if (authStore.userId) {
        await cartStore.fetchCart();
    }

    watch(
        () => authStore.userId,
        async (newU, oldU) => {
            if (newU && !oldU) {
                await cartStore.fetchCart();
            } else if (!newU && oldU) {
                cartStore.clearCart();
            }
        }
    );

    await addDynamicRoutes(router, routerStore.routerList);
    await router.isReady();

    await Promise.all([
        commonCodeStore.fetchCommonCodes(),
        // initTossPayments().then((tossPaymentsInstance) => {
        //     if (tossPaymentsInstance) {
        //         app.provide('tossPaymentsInstance', tossPaymentsInstance);
        //     }
        // }),
        initKakaoMap().then((kakaoMapInstance) => {
            if (kakaoMapInstance) {
                app.provide('kakaoMapInstance', kakaoMapInstance);
            }
        })
    ]);

    router.beforeEach((to, from, next) => {
        loadingStore.showLoading(); // 로딩 시작
        next();
    });

    router.afterEach(() => {
        loadingStore.hideLoading(); // 로딩 종료
    });

    // 로그아웃(토큰값변경체크)시 특정조건화면은 루트항목으로 이동
    watch(
        () => authStore.accessToken,
        (newToken) => {
            const currentRouteMeta = router.currentRoute.value.meta || {};
            if (!newToken && currentRouteMeta.authCheck === true) {
                router.replace('/');
            }
        }
    );

    const requestedPath = window.location.pathname;
    const requestedHash = window.location.hash;

    const socialLoginCallbacks = [
        { path: '/login-auth', condition: (hash) => hash.includes('access_token') } // 네이버
        // { path: '/kakao-callback', condition: hash => hash.includes('code') },    // 카카오
    ];
    const isSocialLoginCallback = socialLoginCallbacks.some((callback) => callback.path === requestedPath && callback.condition(requestedHash));

    if (isSocialLoginCallback) {
        if (requestedPath === '/login-auth' && requestedHash.includes('access_token')) {
            const hashParams = new URLSearchParams(requestedHash.substring(1));
            const query = {};
            for (const [key, value] of hashParams.entries()) {
                query[key] = value;
            }
            await router.replace({ path: requestedPath, query: query });
        } else {
            await router.isReady();
        }
    } else {
        const routes = router.getRoutes();
        const matchedRoute = routes.find((route) => route.path === requestedPath);

        if (requestedPath !== '/' && matchedRoute) {
            const query = {};
            const searchParams = new URLSearchParams(window.location.search);
            for (const [key, value] of searchParams.entries()) {
                query[key] = value;
            }
            // 여기서 hash 옵션 없이 path와 query만 사용
            await router.replace({ path: requestedPath, query: query });
        } else if (requestedPath !== '/') {
            await router.replace('/'); // 매칭 안되면 홈으로
        } else await router.replace('/');
        // 루트 경로나 이미 처리된 경우는 isReady만 기다릴 수 있음
        if (!router.currentRoute.value.name) {
            await router.isReady();
        }
    }
    app.mount('#app');
}

initializeApp().catch((error) => {
    console.error('Failed to initialize app:', error);

    // if (error.code === 'ERR_NETWORK') {
    // }
});
